// const $ = window.$cash;
import $ from 'cash-dom';
export default function () {
  console.log('FORM-FIX')
  if ($) {
    function setFilled(el) {
      const wrapper = $(el).closest('.wpforms-field');
      const filled = (el.value && el.value !== '');
      // console.log('FILLED', filled);
      wrapper.toggleClass('js-filled', filled);
    }

    $(() => {
      $('.contact_form').find('.wpforms-field-text,.wpforms-field-number').find('input').each((i, el) => {
        // set filled?
        setFilled(el);
      })
      $('.contact_form').find('.wpforms-field-text,.wpforms-field-number').find('input').on({
        change: (e) => {
          setFilled(e.target);
        },
        focus: (e) => {
          const wrapper = $(e.target).closest('.wpforms-field');
          wrapper.addClass('js-active');

        },
        blur: (e) => {
          const wrapper = $(e.target).closest('.wpforms-field');
          wrapper.removeClass('js-active');
        }
      });
    })
  }
}
